
import { ApiService }                 from '../api/api.service';
import { CompanyIntegrationsModel }   from '../companies/models/company.integrations';
import { HaynesProSettingsComponent } from './haynes-pro.settings.component';
import { SessionService }             from '../sessions/session.service';

export const HaynesProStates : Array<any> = [
  {
    component: HaynesProSettingsComponent,
    name     : 'app.haynes-pro-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<CompanyIntegrationsModel> => apiService.get('/company_integrations'),
        token    : 'settings'
      }
    ],
    url: '/haynes-pro-settings'
  }
];